/* multi-value.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import "./multi-value.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { cx } from '@compiled/react';
import CrossIcon from '@atlaskit/icon/core/cross';
import LegacySelectClearIcon from '@atlaskit/icon/glyph/select-clear';
import { getStyleProps } from '../utils';
var multiValueStyles = {
  root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazjpor _3yq3glyw",
  disabled: "_syaz1gmx _bfhki8nm",
  focused: "_syaz1wum _bfhk15s3 _16qs7ex6 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
export var multiValueCSS = function multiValueCSS() {
  return {};
};
export var multiValueLabelCSS = function multiValueLabelCSS() {
  return {};
};
var multiValueLabelStyles = {
  root: "_1reo15vq _18m915vq _2rkolb4i _11c82smr _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
  disabled: "_syaz1gmx",
  ellipsis: "_1bto1l2s"
};
export var multiValueRemoveCSS = function multiValueRemoveCSS() {
  return {};
};
var multiValueRemoveStyles = {
  focused: "_bfhkb1q9 _lswu1rrc",
  root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _1e0c1txw _lswu1dx5 _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr31dpa _13br1jjn _1di6fcek _i5f81jjn"
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var MultiValueContainer = function MultiValueContainer(_ref) {
  var children = _ref.children,
    innerProps = _ref.innerProps,
    isFocused = _ref.isFocused,
    isDisabled = _ref.isDisabled,
    className = _ref.className,
    xcss = _ref.xcss;
  return /*#__PURE__*/React.createElement("div", _extends({}, innerProps, {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    className: ax([multiValueStyles.root, isDisabled && multiValueStyles.disabled, isFocused && multiValueStyles.focused, cx(className, xcss, '-multiValue')])
  }), children);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var MultiValueLabel = function MultiValueLabel(_ref2) {
  var children = _ref2.children,
    innerProps = _ref2.innerProps,
    isDisabled = _ref2.isDisabled,
    hasEllipsis = _ref2.hasEllipsis,
    className = _ref2.className,
    xcss = _ref2.xcss;
  return /*#__PURE__*/React.createElement("div", _extends({}, innerProps, {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    className: ax([multiValueLabelStyles.root, isDisabled && multiValueLabelStyles.disabled, hasEllipsis && multiValueLabelStyles.ellipsis, cx(className, xcss, '-MultiValueLabel')])
  }), children);
};
var disabledStyles = null;
var enabledStyles = null;
export function MultiValueRemove(_ref3) {
  var isDisabled = _ref3.isDisabled,
    isFocused = _ref3.isFocused,
    innerProps = _ref3.innerProps,
    className = _ref3.className,
    xcss = _ref3.xcss;
  return /*#__PURE__*/React.createElement("div", _extends({}, innerProps, {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    className: ax([multiValueRemoveStyles.root, isFocused && multiValueRemoveStyles.focused, cx(className, xcss, '-MultiValueRemove')])
  }), /*#__PURE__*/React.createElement("div", {
    "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
    className: ax([isDisabled && "_1e0cglyw", !isDisabled && "_1e0c1kw7"])
  }, /*#__PURE__*/React.createElement(CrossIcon, {
    label: "",
    color: "currentColor",
    LEGACY_fallbackIcon: LegacySelectClearIcon,
    LEGACY_primaryColor: "transparent",
    LEGACY_secondaryColor: "inherit",
    LEGACY_size: "small",
    size: "small"
  })));
}
var MultiValue = function MultiValue(props) {
  var children = props.children,
    components = props.components,
    data = props.data,
    innerProps = props.innerProps,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    removeProps = props.removeProps,
    selectProps = props.selectProps,
    cropWithEllipsis = props.cropWithEllipsis;
  var Container = components.Container,
    Label = components.Label,
    Remove = components.Remove;
  var ariaLabel = typeof children === 'string' ? children : data.label;
  var _getStyleProps = getStyleProps(props, 'multiValue', {
      'multi-value': true,
      'multi-value--is-disabled': isDisabled
    }),
    containerCss = _getStyleProps.css,
    containerClassName = _getStyleProps.className;
  var _getStyleProps2 = getStyleProps(props, 'multiValueLabel', {
      'multi-value__label': true
    }),
    labelCss = _getStyleProps2.css,
    labelClassName = _getStyleProps2.className;
  var _getStyleProps3 = getStyleProps(props, 'multiValueRemove', {
      'multi-value__remove': true
    }),
    removeCss = _getStyleProps3.css,
    removeClassName = _getStyleProps3.className;
  return /*#__PURE__*/React.createElement(Container, {
    data: data,
    innerProps: _objectSpread({
      style: containerCss,
      className: containerClassName
    }, innerProps)
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    ,
    className: containerClassName,
    isFocused: isFocused,
    isDisabled: isDisabled,
    selectProps: selectProps
  }, /*#__PURE__*/React.createElement(Label, {
    data: data,
    innerProps: {
      style: labelCss,
      className: labelClassName
    }
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    ,
    className: labelClassName,
    hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
    selectProps: selectProps
  }, children), /*#__PURE__*/React.createElement(Remove, {
    data: data,
    innerProps: _objectSpread({
      style: removeCss,
      className: removeClassName,
      role: 'button',
      tabIndex: -1,
      'aria-label': "".concat(ariaLabel || 'option', ", remove")
    }, removeProps)
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    ,
    className: removeClassName,
    isDisabled: isDisabled,
    selectProps: selectProps
  }));
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default MultiValue;